export const openStatisticCenter = (url: string) => {
    var wnd = window.open(
        url,
        'statistic',
        'width=1280,height=720,scrollbars=1,resizable=1')
    // window.open seems to return null on IE9
    if (wnd) {
        wnd.focus()
    }
}